import AppPublicRoutes from "./AppPublicRoutes";

export default AppPublicRoutes;
